<style scoped>
    .itemBox{
        margin-top: .16rem;
        height: .88rem;
        padding: 0 .24rem;
        display: flex;
        align-items: center;
        background: #fff;
    }

    .name{
        width: 1.2rem;
        font-size: .3rem;
        color: #212121;
        margin-right: .7rem;
    }
    input{
        border: none;
        font-size: .3rem;
        color: #212121;
    }
    input::placeholder{
        color: #AEAEAE;
    }
    input:disabled{
        background: #fff;
    }
    .send{
        width: 1.52rem;
        height: .54rem;
        background: #00C59F;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .24rem;
        color: #fff;
        border-radius: .06rem;
        margin-left: .1rem;
    }
    .btn{
        width: 7.02rem;
        height: .8rem;
        border-radius: .1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .3rem;
        color: #fff;
        margin: 1.5rem auto 0;
        background: #00C59F;
    }
</style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="修改手机号"></topbar>
        <div class="itemBox">
            <div class="name">新手机号</div>
            <input type="text" placeholder="请输入您的新手机号码" v-model="doctorPhone">
        </div>
        <div class="itemBox">
            <div class="name">密码</div>
            <input type="text" placeholder="请输入您的密码" v-model="doctorPsw">
        </div>
        <div class="itemBox">
            <div class="name">验证码</div>
            <input type="text" placeholder="请输入手机验证码" v-model="code">
            <div class="send" v-if="status===0" @click="getSmsAuthCode">获取验证码</div>
            <div class="send" v-if="status===1">{{num}}</div>
            <div class="send" v-if="status===2" @click="getSmsAuthCode">重新获取</div>
        </div>
        <div class="btn" @click="sure">确定</div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                num: 59,
                status: 0,
                doctorPhone: '',
                doctorPsw: '',
                code:''
            }
        },
        components: {
            noMoreData,
            topbar,
        },
        filters: {

            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            sure(){
                if(!this.doctorPhone){
                    alert('请输入手机号')
                }else if(!this.doctorPsw){
                    alert(`请输入密码`)
                }else if(!this.code){
                    alert(`请输入验证码`)
                }else{
                    this.changeDoctorPhone()
                }
            },
            signOut(){
                localStorage.removeItem('doctorId')
                localStorage.removeItem('doctorName')

                if(!localStorage.getItem('doctorId')){
                    this.$router.push(`/login`)
                }else{
                    setTimeout(()=>{
                        this.$router.push(`/login`)
                    },200)
                }
            },
            async changeDoctorPhone() {
                let data = await getSources("/bear-scale/api/chatDoctor/changeDoctorPhone.json",{doctorId:localStorage.getItem('doctorId'),doctorPhone:this.doctorPhone,code:this.code,doctorPsw:this.doctorPsw});
                if (data.status === 0) {
                    this.signOut();
                }else{
                    alert(data.msg)
                }
            },
            async getSmsAuthCode() {
                if(!this.doctorPhone){
                    alert('请先输入手机号')
                    return
                }
                let data = await getSources("/bear-scale/api/scaleUserInfo/getSmsAuthCode.json",{userPhone:this.doctorPhone});
                if (data.status === 0) {
                    alert('发送成功')
                    this.status = 1
                    this.num = 59

                    // this.$nextTick(() => {
                    // 	this.$refs.code.focus()
                    // })

                    const that = this

                    setTimeout(function codeFormat() {
                        that.num--

                        if (that.num) {
                            setTimeout(codeFormat, 1000)
                        } else {
                            that.status = 2
                        }
                    }, 1000)


                    return
                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed(){

        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/changePhone.vue